<div
  [class.absolute]="!inline"
  [ngStyle]="getStyles()"
  aria-label="Loading"
  class="loading"
  data-test="loading"
  role="progressbar"
>
  <div
    class="animation"
    [ngClass]="{
      'animation-primary': color === 'primary',
      'animation-white': color === 'white'
    }"
  >
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
</div>
